import React from "react";
import type { RouteObject } from "react-router-dom";

const NaverCardPage = React.lazy(() => import("../page/NaverCardPage.tsx"));

export const TestPageRoute: RouteObject[] = [
  {
    path: "test-page",
    children: [
      {
        path: "naver-cards",
        element: <NaverCardPage />,
      },
    ],
  },
];
